import { ds } from "js/core/models/dataService";
import { NodeType } from "common/constants";
import { _, $ } from "js/vendor";
import { getStaticUrl } from "js/config";
import { controls } from "js/editor/ui";
import renderReactRoot from "js/react/renderReactRoot";
import log from "js/core/logger";

import { ElementOptionsMenu } from "../BaseElementEditor";
import { CollectionElementSelection } from "../CollectionElementEditor";
import { ImageFrameMenu } from "../EditorComponents/ImageFrameMenu";

const TimelineSelection = CollectionElementSelection.extend({
    renderControls: function() {
        this.addMilestonePromiseChain = Promise.resolve();

        this.addControl({
            type: controls.BUTTON,
            label: "Add Milestone",
            icon: "add_circle",
            enabled: this.element.annotations.itemCount < this.element.annotations.maxItemCount,
            callback: () => {
                this.addMilestonePromiseChain = this.addMilestonePromiseChain
                    .then(async () => {
                        const annotations = this.element.annotations;

                        const annotationModel = this.element.getDefaultAnnotationModel();
                        annotationModel.x = annotations.model.items.reduce((x, itemModel) => Math.max(x, itemModel.x), 0);
                        annotationModel.x = (1 - annotationModel.x) / 2 + annotationModel.x;

                        const annotation = annotations.addItem(annotationModel);

                        if (!annotations.model.items.some(itemModel => itemModel.hasBeenDragged)) {
                            await this.element.canvas.refreshCanvas({ transition: true });
                            await this.element.distributeMilestones();
                        }

                        await this.element.canvas.updateCanvasModel(true);

                        ds.selection.element = annotations.getItemElementById(annotation.id);
                    })
                    .catch(err => log.error(err));
            }
        });

        this.addControl({
            id: "nodeType",
            type: controls.POPUP_BUTTON,
            icon: "apps",
            showArrow: false,
            menuClass: "icon-menu fivecol",
            items: [{
                label: "Text",
                value: NodeType.TEXT,
                image: getStaticUrl("/images/ui/node_types/node_text.svg")
            }, {
                label: "Bullet",
                value: NodeType.BULLET_TEXT,
                image: getStaticUrl("/images/ui/node_types/node_bullet_text.svg")
            }, {
                label: "Numbered",
                value: NodeType.NUMBERED_TEXT,
                image: getStaticUrl("/images/ui/node_types/node_numbered_text.svg")
            }, {
                label: "Lettered",
                value: NodeType.LETTERED_TEXT,
                image: getStaticUrl("/images/ui/node_types/node_lettered_text.svg")
            }, {
                label: "Media with Text",
                value: NodeType.CONTENT_AND_TEXT,
                image: getStaticUrl("/images/ui/node_types/node_content_and_text.svg")
            }],
            callback: value => {
                ds.selection.element = null;
                this.element.model.annotations.items.forEach(itemModel => itemModel.nodeType = value);
                this.element.canvas.updateCanvasModel(true);
            }
        });

        const contentAndTextElement = this.element.annotations.itemElements.find(element => element?.nodeType === NodeType.CONTENT_AND_TEXT);
        if (contentAndTextElement) {
            this.addControl({
                type: controls.POPUP_BUTTON,
                icon: "filter_frames",
                showArrow: false,
                customMenuClass: "frame-popup",
                menuContents: closeMenu => {
                    const $menu = $.div();
                    renderReactRoot(
                        ImageFrameMenu,
                        {
                            onSelect: frame => {
                                this.element.annotations.itemElements.forEach(annotation => {
                                    annotation.model.frameType = frame;
                                    annotation.markStylesAsDirty();
                                });
                                this.element.canvas.updateCanvasModel(false);
                                closeMenu();
                            },
                            allowedCategories: contentAndTextElement.options.allowedFrameCategories
                        },
                        $menu[0]
                    );
                    return $menu;
                },
                transitionModel: false
            });
        }

        this.addControl({
            type: controls.BUTTON,
            label: "Auto Arrange",
            icon: "view_column",
            callback: () => {
                (async () => {
                    await this.element.distributeMilestones();
                    await this.element.canvas.updateCanvasModel(true);
                })();
            }
        });
    }
});

const TimelineOptionsMenu = ElementOptionsMenu.extend({
    renderControls: function() {
        this.addControl({
            type: controls.TOGGLE,
            label: "Start Marker",
            property: "showStartMarker"
        });

        this.addControl({
            type: controls.TOGGLE,
            label: "End Marker",
            property: "showEndMarker"
        });
    }
});

export const editors = {
    TimelineSelection,
    TimelineOptionsMenu
};
